/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 源格式类型
 */
export const From = {
  Plain: "plain",
  Base64: "base64",
  Hex: "hex",
  Url: "url",
  Html: "html",
  Unicode: "unicode",
  Binary: "binary",
  Md5: "md5",
  Sha1: "sha1",
  Sha256: "sha256",
  Sha512: "sha512",
} as const;
/**
 * 源格式类型
 */
export type From = ClosedEnum<typeof From>;

export const From$zodSchema = z.enum([
  "plain",
  "base64",
  "hex",
  "url",
  "html",
  "unicode",
  "binary",
  "md5",
  "sha1",
  "sha256",
  "sha512",
]).describe("源格式类型");

/**
 * 目标格式类型
 */
export const To = {
  Plain: "plain",
  Base64: "base64",
  Hex: "hex",
  Url: "url",
  Html: "html",
  Unicode: "unicode",
  Binary: "binary",
  Md5: "md5",
  Sha1: "sha1",
  Sha256: "sha256",
  Sha512: "sha512",
} as const;
/**
 * 目标格式类型
 */
export type To = ClosedEnum<typeof To>;

export const To$zodSchema = z.enum([
  "plain",
  "base64",
  "hex",
  "url",
  "html",
  "unicode",
  "binary",
  "md5",
  "sha1",
  "sha256",
  "sha512",
]).describe("目标格式类型");

/**
 * 包含转换配置的JSON对象
 */
export type PostTextConvertRequest = {
  text: string;
  from: From;
  to: To;
  options?: { [k: string]: any } | undefined;
};

export const PostTextConvertRequest$zodSchema: z.ZodType<
  PostTextConvertRequest
> = z.object({
  from: From$zodSchema,
  options: z.record(z.string(), z.any()).optional(),
  text: z.string(),
  to: To$zodSchema,
}).describe("包含转换配置的JSON对象");

/**
 * 转换失败或参数错误
 */
export type PostTextConvertBadRequestResponseBody = {
  error_code?: string | undefined;
  error_message?: string | undefined;
  error_details?: string | undefined;
};

export const PostTextConvertBadRequestResponseBody$zodSchema: z.ZodType<
  PostTextConvertBadRequestResponseBody
> = z.object({
  error_code: z.string().optional(),
  error_details: z.string().optional(),
  error_message: z.string().optional(),
}).describe("转换失败或参数错误");

/**
 * 转换成功
 */
export type PostTextConvertResponseBody = {
  result?: string | undefined;
  from?: string | undefined;
  to?: string | undefined;
  length?: number | undefined;
  info?: string | undefined;
};

export const PostTextConvertResponseBody$zodSchema: z.ZodType<
  PostTextConvertResponseBody
> = z.object({
  from: z.string().optional(),
  info: z.string().optional(),
  length: z.int().optional(),
  result: z.string().optional(),
  to: z.string().optional(),
}).describe("转换成功");

export type PostTextConvertResponse =
  | PostTextConvertResponseBody
  | PostTextConvertBadRequestResponseBody;

export const PostTextConvertResponse$zodSchema: z.ZodType<
  PostTextConvertResponse
> = z.union([
  z.lazy(() => PostTextConvertResponseBody$zodSchema),
  z.lazy(() => PostTextConvertBadRequestResponseBody$zodSchema),
]);
